<template>
    <split-pane  :min-percent='10' :default-percent='15' split="vertical"  style="background:white; height:99%">
        <template slot="paneL">
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"  ></el-input> 
            <el-tree :data="treeData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"    
                        :default-expanded-keys="expkeys"     
                        :style="{background:'#fff',overflow:'auto',height: scrollerHeight}"
                        highlight-current
                        v-loading="loadingtree"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"    
                        :filter-node-method="filterNode"
                        ref="eltree"
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  >
                        <span  style="color:#F56C6C;font-size:14px;"><i class="iconfont icon-_shujuzidian" style="color:#F56C6C;font-size:18px;"></i> {{ node.label}} </span>
                    </span>                  
                    <span v-else  > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i>{{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
        </template>
        <template slot="paneR"> 
            <div style=" background:#fff; display:flex;line-height:30px;border-bottom:2px solid #389;padding-top:3px; " >
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false"  ><span style="font-size:12px;">新增 </span></el-link>
                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:18px;"></i>
                <el-link :disabled="editBool" @click="editRec" :underline="false"  ><span style="font-size:12px;">编辑 </span></el-link>
                <i class="iconfont icon-baocun" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:18px;"></i>
                <el-link :disabled="editBool" @click="saveRec" :underline="false"  ><span style="font-size:12px;">保存 </span></el-link>
                <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:15px ">
                    <span v-for="item in tabArr" :key='item.key' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input clearable :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                </el-input>
            </div>
            <el-table  :data="baseData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    :row-key="getRowKeys"
                    :header-cell-style="{background:'#9fcaf887'}"
                    :row-class-name="tabRowClass"
                    size="small"
                    ref="tabref"
                     cell-class-name="clearPadding"
                    :height="tabHeight" 
                    @row-click="rowClick"
                    highlight-current-row>
                <el-table-column type="index" label="序号" width="65"></el-table-column>
                <el-table-column   
                    prop="FRMNM"
                    label="表单名称"
                    show-overflow-tooltip
                    align="center"                                  
                    min-width="110">
                </el-table-column> 
                <el-table-column   
                    prop="FRUSER"
                    label="发起人"
                    show-overflow-tooltip
                    align="center"                                  
                    min-width="140">
                    <template slot-scope="scope" >
                        <span v-if="qryFlag" v-text="scope.row['FRUSERNM']" ></span>
                        <el-select v-else v-model="scope.row[scope.column.property]"  placeholder="请选择" filterable clearable size="mini" style="width:100% ">
                            <span v-for="item in userArr" :key='item.key' >
                                <el-option :label="item.USERNM" :value="item.USERNO" :disabled="item.STFG=='X'" ></el-option>
                            </span>
                        </el-select>
                    </template>
                </el-table-column> 

                <el-table-column label="一级审核" align="center" style="background:white">
                    <el-table-column   
                        prop="CHKUSER1"
                        label="审核用户"
                        show-overflow-tooltip
                        align="center"                                  
                        min-width="140">
                        <template slot-scope="scope" >
                            <span v-if="qryFlag" v-text="scope.row['CHKNM1']" ></span>
                            <el-select v-else v-model="scope.row[scope.column.property]"  placeholder="请选择" filterable clearable size="mini" style="width:100% ">
                                <span v-for="item in userArr" :key='item.key' >
                                    <el-option :label="item.USERNM" :value="item.USERNO" :disabled="item.STFG=='X'"></el-option>
                                </span>
                            </el-select>
                        </template>
                    </el-table-column> 
 
                    <el-table-column   
                        prop="TXT01"
                        label="条件判断"
                        show-overflow-tooltip
                        align="center"                                  
                        min-width="180">
                        <template slot-scope="scope" >
                            <span v-if="qryFlag" v-text="scope.row[scope.column.property]" ></span>
                            <el-input v-else size="mini" v-model="scope.row[scope.column.property]" ></el-input>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="二级审核" align="center" style="background:white">
                    <el-table-column   
                        prop="CHKUSER2"
                        label="审核用户"
                        show-overflow-tooltip
                        align="center"                                  
                        min-width="140">
                        <template slot-scope="scope" >
                            <span v-if="qryFlag" v-text="scope.row['CHKNM2']" ></span>
                            <el-select v-else v-model="scope.row[scope.column.property]"  placeholder="请选择" filterable clearable size="mini" style="width:100% ">
                                <span v-for="item in userArr" :key='item.key' >
                                    <el-option :label="item.USERNM" :value="item.USERNO" :disabled="item.STFG=='X'"></el-option>
                                </span>
                            </el-select>
                        </template>
                    </el-table-column> 
 
                    <el-table-column   
                        prop="TXT02"
                        label="条件判断"
                        show-overflow-tooltip
                        align="center"                                  
                        min-width="180">
                        <template slot-scope="scope" >
                            <span v-if="qryFlag" v-text="scope.row[scope.column.property]" ></span>
                            <el-input v-else size="mini" v-model="scope.row[scope.column.property]" ></el-input>
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="三级审核" align="center" style="background:white">
                    <el-table-column   
                        prop="CHKUSER3"
                        label="审核用户"
                        show-overflow-tooltip
                        align="center"                                  
                        min-width="140">
                        <template slot-scope="scope" >
                            <span v-if="qryFlag" v-text="scope.row['CHKNM3']" ></span>
                            <el-select v-else v-model="scope.row[scope.column.property]"  placeholder="请选择" filterable clearable size="mini" style="width:100% ">
                                <span v-for="item in userArr" :key='item.key' >
                                    <el-option :label="item.USERNM" :value="item.USERNO" :disabled="item.STFG=='X'"></el-option>
                                </span>
                            </el-select>
                        </template>
                    </el-table-column> 
                    <el-table-column   
                        prop="TXT03"
                        label="条件判断"
                        show-overflow-tooltip
                        align="center"                                  
                        min-width="180">
                        <template slot-scope="scope" >
                            <span v-if="qryFlag" v-text="scope.row[scope.column.property]" ></span>
                            <el-input v-else size="mini" v-model="scope.row[scope.column.property]" ></el-input>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="四级审核" align="center"  >
                    <el-table-column   
                        prop="CHKUSER4"
                        label="审核用户"
                        show-overflow-tooltip
                        align="center"                                  
                        min-width="140">
                        <template slot-scope="scope" >
                            <span v-if="qryFlag" v-text="scope.row['CHKNM4']" ></span>
                            <el-select v-else v-model="scope.row[scope.column.property]"  placeholder="请选择" filterable clearable size="mini" style="width:100% ">
                                <span v-for="item in userArr" :key='item.key' >
                                    <el-option :label="item.USERNM" :value="item.USERNO" :disabled="item.STFG=='X'"></el-option>
                                </span>
                            </el-select>
                        </template>
                    </el-table-column> 
                    <el-table-column   
                        prop="TXT04"
                        label="条件判断"
                        show-overflow-tooltip
                        align="center"                                  
                        min-width="180">
                        <template slot-scope="scope" >
                            <span v-if="qryFlag" v-text="scope.row[scope.column.property]" ></span>
                            <el-input v-else size="mini" v-model="scope.row[scope.column.property]" ></el-input>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column   
                    prop="RMK"
                    label="备注"
                    show-overflow-tooltip
                    align="center"                                  
                    min-width="140">
                    <template slot-scope="scope" >
                        <span v-if="qryFlag" v-text="scope.row[scope.column.property]" ></span>
                        <el-input v-else size="mini" v-model="scope.row['RMK']" ></el-input>
                    </template>
                </el-table-column>
                <el-table-column   
                    prop="ADDUSER"
                    label="新增用户"
                    show-overflow-tooltip
                    align="center"                                  
                    min-width="100">
                </el-table-column>
                <el-table-column   
                    prop="ADDDTTM"
                    label="新增日期"
                    show-overflow-tooltip
                    align="center"                                  
                    min-width="120">
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="72">
                    <template slot-scope="scope">
                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="delBool " @click="delRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px; ">删除</span></el-link>    
                    </template>
                </el-table-column>                         
            </el-table>
 
            <!-- 提示框 -->
            <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div> 
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
        </template>
    </split-pane>
</template>

<script>
    import { getTabColOrData,getBaseData } from '../../api/user'
    import {getDate} from '../../api/Select' 
    export default {
        name: "flow_set",
        data(){
            return {
                userArr:[],
                treeData:[] ,//  树数据
                filterText: '',
                qryFlag:true,
                input_hold:'请输入内容...',
                defaultProps: {  //el-tree 默认字段属性
                    children: 'children',
                    id:'id',
                    parentid:'parentid',
                    icon:'icon',
                    label: 'label'
                },
                parentid:'',
                operArr:[],
                oper:'like',
                notNull:[],
                expkeys:['0'],
                treeid :'0',
 
                v_sys:this.$cookies.get('v_sys'), //系统标志
 
                v_usernm:this.$cookies.get('v_usernm') ,
                loading:false,// table加载bool
                loadingtree:false,
                txtparam:'', // input 绑定值
                selparam:'FRUSER',// select 绑定值
                tabArr:[] ,//表列格式化集合
                baseData:[] ,//表数据
                fldArr:[],
                nodeLabel:'全部表单',
                chkIndex:'',
                stfgBool:true,
                delDtlData:[],
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                v_url:'xuper_auth/getTableRecMany', //动态请求url接口
                promptWin:false,
                prompt:'',
                addBool:false, //新增,为true时--禁止
                editBool:false, //编辑,为true时--禁止
                delBool:false, //删除 ,为true时--禁止
                cfmBool:false, //审核 ,为true时--禁止
                cancelBool:false, //作废 ,为true时--禁止
                v_admin:this.$cookies.get('v_admin') , 
            }
        },
        created(){
            if (this.v_username){ 
                //初始化
                this.getData(); //树形数据
                this.getTabCol(); //表列数据
                this.getTabData( this.treeid,''); //表记录数据
            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        watch: {
            filterText(val) {
                this.$refs.eltree[0].filter(val);
            }
        },
        mounted(){
            //用户表单新增、编辑、审核、作废权限  
            getBaseData(this.v_url,'userno',this.v_username,'frmidseq','407221','v_sys_user_priv','').then(res=>{           
                if (this.v_admin==='N') { //表示有权限控制
                    let row =res.result[0]
                    if (row.ISADD==='N'){ //新增
                        this.addBool=true
                    }if (row.ISUPD==='N'){ //修改
                        this.editBool=true
                    }if (row.ISDEL==='N'){ //删除
                        this.delBool=true
                    }if (row.ISCFM==='N'){ //审核
                        this.cfmBool=true
                    }if (row.ISCANCEL==='N'){ //作废
                        this.cancelBool=true
                    }
                }
            }) 
 
            //操作符
            getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
                this.operArr =res.result
            })
            getBaseData(this.v_url,'corpid',this.v_corpid,'isout','N','v_sys_user','').then(res=>{
                this.userArr =res.result
            })
        },
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 125) + 'px';
            },
            tabHeight(){
                return window.innerHeight-125+ 'px'
            }  
            
        },
 
        methods:{
            rowClick(row){
                this.chkIndex =row.index
            },
            tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
                row.index =rowIndex
            },
            getRowKeys(row){
                return row.index
            },
            //节点过滤
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            //节点点击
            handleNodeClick(data ){
                this.qryFlag=true
                this.nodeLabel=data.label            
                this.treeid =data.id
                this.parentid =data.parentid
                this.getTabData( data.id,'')
                this.delDtlData =[]
            },
 
            //确定
            saveRec(){
                var vm=this;
                //发起保存请求   
                if (!this.qryFlag) { 
                    //2.4、明细删除
                    for (let k=0;k<this.delDtlData.length;k++) {
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:this.delDtlData[k].IDSEQ,p_key2:'lstseq',p_value2:this.delDtlData[k].LSTSEQ, p_table:'SYS_FORM_FLOW'  },
                        }).then(res=>{
                            if (res.code!=='200'){
                                this.promptWin =true
                                this.prompt =res.result
                            }
                        })  
                    } 
                    //2.3、明细保存            
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/batDtlSave2',
                        data: {p_json:JSON.stringify( this.baseData ), p_table:'SYS_FORM_FLOW',p_idseq: this.treeid,p_action:'S'},
                    }).then(res=>{
                        if (res.code!=='200'){
                            this.promptWin =true
                            this.prompt =res.result
                        }else{
                            this.qryFlag =true
                            vm.getTabData( vm.treeid,'') 
                        }
                    })   
                }else{
                    this.$message.error('没有记录需要保存')
                }
            } ,
            //新增
            addRec(){
                if (this.treeid==0 || this.parentid==0){
                    this.promptWin =true
                    this.prompt ='请选择表单节点'
                }else {
                    this.qryFlag=false
                    let v_data={FRMNM:this.nodeLabel,ADDUSER:this.v_usernm,ADDDTTM:getDate('full'),CORPID:this.v_corpid}
                    this.baseData.push(v_data)
                }               
            },
            editRec(){
                this.qryFlag =false
            },
            //删除
            delRec(row,index){
                this.$Modal.confirm({
                    title: '删除确认',
                    content: '<p>你确定要删除此行记录吗</p>',
                    onOk: () => {
                        //发起删除请求
                        var vm=this;
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'LSTseq',p_value2:row['LSTSEQ'],p_table:'SYS_FORM_FLOW'},
                        }).then(res=>{      
                            if(res.code =='200')  {   
                                this.delDtlData.push(row)        
                                this.baseData.splice(index,1)

                            }else{
                                this.prompt =res.message
                                this.promptWin =true
                            }        
                        }) 
                    }
                })
            },
 
            //查询事件
            qryTabData(){
                let cond_=''
                if (this.selparam){ //列1
                    if (this.oper==='like'){
                        cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                    }else{
                        cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                    }
                }
                this.getTabData( this.treeid,cond_);
            },
            // 获取 树形控件数据
            getData() {  
                var vm=this;
                this.loadingtree=true
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getElTreeData' ,
                    data: {p_table:'V_FLOW_FORM' }
                }).then(function(res){                  
                    vm.treeData =res.result   
                    if(res.result.length > 0 ){
                        //'nextTick()' 下次dom更新时触发回调函数
                        vm.$nextTick(() =>{
                            //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                            vm.$refs.eltree.setCurrentKey(vm.treeid)
                            vm.expkeys.push(vm.treeid)
                        })
                    }  
                    vm.loadingtree =false           
                })                              
            },
            //获取表列头字段
            getTabCol(){
                var vm=this
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407221','lstseq','1','','',' order by sortby,lstseq').then((res) => { 
                    for (let k=0; k<res.result.length; k++){
                        vm.tabArr.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            edcss:res.result[k].EDCSS,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            sortable: res.result[k].sortable?true:false,
                        })
                    }
                });
            },
 
            //获取表数据
            getTabData(v_value,cond){
                var vm=this
                getTabColOrData(this.v_url,'V_SYS_FORM_FLOW','idseq',v_value,'','','','',cond).then((res) => {
                    //保存取到 所有数据
                    vm.baseData =res.result 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout();
                        //this.$refs.tabref.setCurrentRow(this.currRow )
                    })
                });               
            }
        }
    }
</script>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
</style>
<style scoped lang="less">
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
